/*
 * @Author: your name
 * @Date: 2021-08-09 10:15:11
 * @LastEditTime: 2022-08-15 17:34:31
 * @LastEditors: Please set LastEditors
 * @Description: 处理点位坐标
 * @FilePath: \smart-community\src\components\map\js\modular\handleCoordinates.js
 */
import {
  Projection,
  addProjection,
  addCoordinateTransforms,
  transform
} from "ol/proj";
import {
  bd09togcj02,
  gcj02towgs84,
  wgs84togcj02,
  gcj02tobd09
} from "coordtransform";
import projzh from "projzh";
export default function handleCoordinates() {
  // 坐标转换
  const setPoint = point => {
    if (!(point && point[0] && point[1])) {
      return;
    }
    let poi = bd09togcj02(...point); // 百度经纬度坐标转火星坐标
    poi = gcj02towgs84(...poi); // 国测局坐标转wgs84坐标
    // console.log(...point, "...point");
    // console.log(poi, "poi");
    // console.log(...poi, "...poi");
    return transform(poi, "EPSG:4326", "baidu");
  };
  // 坐标逆向转换
  const reversePoint = point => {
    if (!(point && point[0] && point[1])) {
      return;
    }
    // 投影转换坐标
    let poi = transform(point, "baidu", "EPSG:4326");
    // wgs84转国测局坐标
    poi = wgs84togcj02(...poi);
    // 国测局坐标转百度经纬度坐标
    poi = gcj02tobd09(...poi);
    return poi;
  };
  // 华智坐标转百度坐标
  const setVideoPoint = point => {
    if (!(point && point[0] && point[1])) {
      return;
    }
    let poi = wgs84togcj02(...point); // wgs84坐标转国测局坐标
    poi = gcj02tobd09(...poi); // 国测局坐标转百度
    poi = transform(poi, "EPSG:4326", "baidu");
    return transform(poi, "baidu", "EPSG:4326");
  };
  // 华智坐标逆向转
  const reverseVideoPoint = point => {
    if (!(point && point[0] && point[1])) {
      return;
    }
    return transform(point, "baidu", "EPSG:4326");
  };
  // 百度坐标转GPS
  const BaiduToGPS = point => {
    if (!(point && point[0] && point[1])) {
      return;
    }
    return gcj02towgs84(...bd09togcj02(...point));
  };
  // 处理GPS坐标
  const coordinatesGPS = () => {
    var bd09Extent = [
      7521710.275907801,
      1089748.66288583074,
      15641596.651638819,
      7293274.359150837
    ];
    var baiduMercator = new Projection({
      code: "baidu",
      extent: bd09Extent,
      units: "m"
    });
    addProjection(baiduMercator);

    addCoordinateTransforms(
      "EPSG:4326",
      baiduMercator,
      projzh.ll2bmerc,
      projzh.bmerc2ll
    );
    return { projection: "baidu" };
  };
  return {
    coordinatesGPS,
    setPoint,
    reversePoint,
    setVideoPoint,
    reverseVideoPoint,
    BaiduToGPS
  };
}
